import { saveAs } from "file-saver";
import { isArray, isEmpty, isNumber, isObject, some } from "lodash";
import moment from "moment";
import numeral from "numeral";
import queryString from "query-string";
import React from "react";
import i18n from "../utils/i18n";

export const numberFormat = (number, fomat) => {
  if (!isNumber(parseInt(number)) || number < 0 || isNaN(parseInt(number))) {
    return number;
  }
  const formattedNumber = numeral(number).format(fomat || "0,0.00");

  return isNaN(parseInt(formattedNumber)) ? "" : formattedNumber;
};

export const displayError = (error) => {
  if (!isEmpty(error)) {
    if (Array.isArray(error)) {
      return error.join("\n");
    }
    if (isObject(error)) {
      let msg = [];
      for (let prop in error) {
        msg.push(error[prop].join("\n"));
      }
      return msg.join("\n");
    }
    return error;
  }
  return "";
};

export const generateOptions = (options) => {
  return options
    ? options.map((item, idx) => {
        return (
          <option key={idx} value={item.value}>
            {item.display_name}
          </option>
        );
      })
    : null;
};

export const objectToFormData = (obj) => {
  let formData = new FormData();

  for (let key in obj) {
    if (obj[key] || obj[key] === 0) {
      if (isArray(obj[key])) {
        obj[key].forEach((val, idx) => {
          formData.append(key + `[${idx}]`, val);
        });
      } else {
        formData.append(key, obj[key]);
      }
    } else {
      formData.append(key, "");
    }
  }
  return formData;
};

export const exportFile = (response, fileName, type) => {
  const blob = new Blob([response.data]);
  if (type !== null && type !== '') {
    saveAs(blob, fileName + "." + type);
  } else {
    saveAs(blob, fileName);
  }
};

export const convertDate = (date, format) => {
  if (!date) return;
  if (!format) {
    format = "YYYY-MM-DD";
  }

  return moment(date).format(format) !== "Invalid date"
    ? moment(date).format(format)
    : null;
};

export const convertTimeUtc = (datetime) => {
  return moment.utc(datetime).local().format("YYYY-MM-DD HH:mm");
};

export const parseQueryParamsForSearch = (query, acceptedParams) => {
  const queryObject = queryString.parse(query);
  const searchParamsObject = {};
  acceptedParams.forEach((param) => {
    searchParamsObject[param] = queryObject.param || "";
  });
  return queryObject;
};

export const isFile = (file) => {
  return file instanceof File || (file && !isEmpty(file.file_path));
};

export const generateId = (id) => {
  const combinedId = "000000" + id;
  return combinedId.substr(combinedId.length - 7);
};

export const displayByBlocks = (text, blocks, seperator) => {
  if (!text) return "";
  let results = [];
  let currentIndex = 0;
  for (let i = 0; i < blocks.length; i++) {
    results.push(text.substr(currentIndex, blocks[i]));
    currentIndex += blocks[i];
  }

  return results.join(seperator);
};

export const returnNullIfEmpty = (input) => {
  if (typeof input == "string") {
    input = toHalfWidthTrimSpace(input);
    return input !== "" ? input : null;
  } else if (typeof input == "object") {
    return input.toString() !== "" ? input : null;
  }
};

export const setRawValue = (event, fieldName, setFieldValue) => {
  setFieldValue(fieldName, event.target.rawValue);
};

export const masterToOptions = (list, defaultValue) => {
  let options = defaultValue ? [defaultValue] : [];
  list.forEach((el) => {
    options.push({
      display_name: el.value,
      value: el.key,
    });
  });
  return options;
};

export const getApiValidationMessage = (error) => {
  return error ? error.reason : "";
};

export const checkValidateInput = (from, to, setFunc) => {
  let haveError = false;
  if (to) {
    haveError = parseInt(from) > parseInt(to);
    setFunc(haveError);
  } else {
    setFunc(false);
  }
  return haveError;
};

export const addHttp = (url) => {
  if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
    url = "http://" + url;
  }
  return url;
};

export const checkPermission = (userGrantedAuthority, listRole) => {
  const grantedPermissions = userGrantedAuthority
    ? userGrantedAuthority.func
    : [];
  return some(grantedPermissions, (grantedPermission) => {
    return listRole.includes(grantedPermission.moduleIdentifier);
  });
};

export const replaceEmptyByNull = (field, value, setFieldValue) => {
  value = value || null;
  setFieldValue(field, value);
};

export const checkEmpty = (input) => {
  input =
    input === undefined || input === null || input === ""
      ? ""
      : typeof input == "string"
      ? input.trim()
      : input;
  if (input === "") {
    return true;
  }
  return false;
};

export const toHalfWidthTrimSpace = (Str) => {
  var value = "";
  let y = "";
  let boolean = false;
  for (var i = 0; i < Str.length; i++) {
    var c = Str.charCodeAt(i);
    if (c === 12288 || c === 32) {
      if (boolean === true) {
        y += String.fromCharCode(c);
        continue;
      }
    } else {
      boolean = true;
      y += String.fromCharCode(c);
      value = y;
    }
  }
  return value;
};

const pad2 = (n) => {
  return (n < 10 ? "0" : "") + n;
};

export const yyyyMMddHHmmSS = () => {
  var date = new Date();
  return (
    date.getFullYear() +
    pad2(date.getMonth() + 1) +
    pad2(date.getDate()) +
    pad2(date.getHours()) +
    pad2(date.getMinutes()) +
    pad2(date.getSeconds())
  );
};

export const yyyyMMdd = () => {
  var date = new Date();
  return date.getFullYear() + pad2(date.getMonth() + 1) + pad2(date.getDate());
};

const getKeysRecursively = (errors) => {
  const currentKey = Object.keys(errors)[0];
  let index = -1;
  if (Array.isArray(errors[currentKey])) {
    errors[currentKey].every(function (value, elem) {
      if (value !== undefined) {
        index = elem;
        return false;
      }
      return true;
    });
    if (index === -1) {
      return "";
    }
    return currentKey
      .concat("[" + index + "].")
      .concat(Object.keys(errors[currentKey][index])[0]);
  }
  return currentKey;
};

export const getFirstError = (errors, apiErrors) => {
  if (Object.keys(errors).length > 0) {
    const selectorKey = getKeysRecursively(errors);
    if (selectorKey !== "") {
      const selector = `[name="${selectorKey}"]`;
      const errorElement = document.querySelector(selector);
      if (errorElement) {
        setTimeout(function () {
          errorElement.focus();
        }, 1000);
      }
    }
  } else if (apiErrors && Object.keys(apiErrors).length > 0) {
    const selectorKey = getKeysRecursively(apiErrors);
    if (selectorKey !== "") {
      const selector = `[name="${selectorKey}"]`;
      const errorElement = document.querySelector(selector);
      if (errorElement) {
        setTimeout(function () {
          errorElement.focus();
        }, 1000);
      }
    }
  }
};

export const convertNullOrUndefinedToEmpty = (input) => {
  return input === undefined || input === null ? "" : input;
};

export const checkUniqueForm = (list, infoName, infoValue) => {
  const arrError = list?.reduce((accumulator, current, index) => {
    if (checkIfAlreadyExist(current)) {
      accumulator = accumulator.
                    reduce((arr,item) => (
                      !(item[infoName] === current[infoName]) && 
                      !(convertNullOrUndefinedToEmpty(item[infoValue]) === convertNullOrUndefinedToEmpty(current[infoValue])) && 
                      arr.push(item), arr
                      ),[]);
      return [...accumulator, current];
    } else {
      return accumulator;
    }
    function checkIfAlreadyExist(currentVal) {
      return list.filter((item) => item.index !== index).some((item) => {
        return (item[infoName] === currentVal[infoName] &&
                convertNullOrUndefinedToEmpty(item[infoValue]) === convertNullOrUndefinedToEmpty(currentVal[infoValue]));
      });
    }
  }, []);
  return arrError === undefined ? [] : arrError;
}

export const setLocaleYup = (Yup) => {
  Yup.setLocale({
    mixed: {
      required: "${label}" + i18n.t("required"),
      typeError: "${label}" + i18n.t("required"),
    },
    string: {
      max: "${label}" + i18n.t("maxLength"),
      matches: "${label}" + i18n.t("regex"),
    },
    number: {
      min: "${label}" + i18n.t("maxNumber"),
      max: "${label}" + i18n.t("minNumber"),
    },
  });
}